// extracted by mini-css-extract-plugin
export default {"wrap":"DealerDocuments_wrap__v2Vmq","form":"DealerDocuments_form__9Ksk9"};